// Zio WhatsApp düğmesi (sections/zio-whatsapp.liquid).
// 1) Görünme gecikmesi + temanın Motion giriş animasyonu (sabit sepete ekle kartıyla aynı süre ve eğri).
// 2) Sabit sepete ekle kartı görününce kartın üstüne kayma: temanın ProductStickyForm koşulunun aynısı
//    (ürün formu ekrandan çıktı VE footer henüz görünmüyor). Mobil alt çubuk kaymasını CSS yapar.
if (!customElements.get('zio-whatsapp')) {
  customElements.define(
    'zio-whatsapp',
    class ZioWhatsapp extends BaseElement {
      connectedCallback() {
        super.connectedCallback();

        if (Shopify.designMode) {
          this.reveal(false);
        }
        else {
          const delay = parseInt(this.dataset.delay, 10) || 0;
          const timer = setTimeout(() => this.reveal(true), delay * 1000);
          this.registerCleanup(() => clearTimeout(timer));
        }

        if (this.hasAttribute('data-sky')) this.watchSky();
        this.watchStickyForm();
      }

      // Gökyüzü stili: ziyaretçinin saatine göre gündüz / gün batımı / gece; sahne sabitlenmişse Liquid'in yazdığı kalır.
      // Gündüz gün doğumu saatinde başlar; gün batımı, ayardaki saatin 1 saat öncesinden 1 saat sonrasına kadar sürer.
      watchSky() {
        if (this.dataset.scene !== 'auto') return;

        const sunrise = parseInt(this.dataset.sunrise, 10) || 7;
        const sunset = parseInt(this.dataset.sunset, 10) || 19;
        let timer = null;
        const update = () => {
          const now = new Date();
          const hour = now.getHours();
          let phase = 'night';
          if (hour >= sunrise && hour < sunset - 1) phase = 'day';
          else if (hour >= sunset - 1 && hour < sunset + 1) phase = 'dusk';
          if (this.dataset.phase !== phase) this.dataset.phase = phase;

          // Faz yalnız saat başında değişir: dakikalık sorgu yerine bir sonraki saat başına tek zamanlayıcı
          clearTimeout(timer);
          const next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour + 1, 0, 1);
          timer = setTimeout(update, next - now);
        };

        update();
        // Uyku / arka plan sekmesi / geri-ileri önbelleği zamanlayıcıyı kaçırabilir → görünür olunca yeniden hesapla
        this.on(document, 'visibilitychange', () => { if (!document.hidden) update(); });
        this.on(window, 'pageshow', (event) => { if (event.persisted) update(); });
        this.registerCleanup(() => clearTimeout(timer));
      }

      reveal(animate) {
        if (this.classList.contains('is-shown')) return;
        this.classList.add('is-shown');

        if (!animate || theme.config.motionReduced || !window.Motion) return;
        Motion.animate(this.firstElementChild, { opacity: [0, 1], transform: ['translateY(15px)', 'translateY(0)'] }, { duration: 1, easing: [0.16, 1, 0.3, 1] });
      }

      watchStickyForm() {
        const stickyForm = document.querySelector('product-sticky-form');
        if (!stickyForm) return;

        const card = stickyForm.firstElementChild;
        const scopeFrom = document.querySelector('.quick-order-list') || document.getElementById(stickyForm.getAttribute('form'));
        const scopeTo = document.querySelector('.footer-group');
        if (!card || !scopeFrom || !scopeTo) return;

        let scopeFromPassed = false;
        let scopeToReached = false;

        const update = () => {
          const visible = scopeFromPassed && !scopeToReached;
          if (visible) this.style.setProperty('--zio-wa-card', `${this.cardLift(stickyForm, card)}px`);
          this.toggleAttribute('data-card', visible);
        };

        const intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === scopeFrom) scopeFromPassed = entry.boundingClientRect.bottom < 0;
            if (entry.target === scopeTo) scopeToReached = entry.isIntersecting;
          });
          update();
        });
        intersectionObserver.observe(scopeFrom);
        intersectionObserver.observe(scopeTo);

        const resizeObserver = new ResizeObserver(update);
        resizeObserver.observe(card);

        this.on(document, 'matchSmall', update);
        this.on(document, 'unmatchSmall', update);
        this.registerCleanup(() => {
          intersectionObserver.disconnect();
          resizeObserver.disconnect();
        });
      }

      // Kartın üst kenarı + 12 px pay − düğmenin kendi alt boşluğu (mobil alt çubuk payı CSS'te ayrıca eklenir)
      cardLift(stickyForm, card) {
        const formBottom = parseFloat(getComputedStyle(stickyForm).bottom) || 0;
        const ownBottom = parseFloat(getComputedStyle(this).bottom) || 0;
        return Math.max(0, Math.round(formBottom + card.offsetHeight + 12 - ownBottom));
      }
    }
  );
}
